module.exports = __webpack_public_path__ + "static/media/newspaper.e93bcb3b.svg";